
import { Vue, Component } from 'vue-property-decorator';
@Component({
    name: 'App',
    components: {},
})
export default class App extends Vue {}
